<div class="row justify-content-center align-items-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">🎉 Success! Your Loan is Booked​</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">
                <div class="row mt-2 justify-content-center">
                    <div class="col-10 text-center successDiv">
                        <p class="sub-heading">Your <b>Travel Now, Pay Later</b> loan has been successfully booked and
                            will be disbursed soon to <b>{{ agentName }}</b>.</p>
                        <div class="success-content">
                            <p class="question">📌 What’s Next?</p>
                            <ol>
                                <li>✅ Loan disbursal is in progress</li>
                                <li>✅ You are all set for your trip to {{ destination }}! ✈️</li>
                            </ol>
                        </div>
                        <div>
                            <h3 class="message">🎊 Pack your bags and have an amazing journey! 🌍✨</h3>
                        </div>
                        <!-- <img src="" class="w-100" alt="success"> -->
                        <button *ngIf="redirect.length > 0" (click)="goBack()" class="btn btn-warning mt-4">Go Back to
                            Partner's Site</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <img src="../../../../assets/images/success.gif" class="w-100 mt-5" alt="success">
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>